import { Link } from 'react-router-dom';
import appstore from '../assets/appstore.svg';
import googleplay from '../assets/googleplay.svg';

export default function Stores(props){
    
    return(
        <div>
            <Link to={props.store === "ios" ? "/ios" : "/android"}>
                <img className="w-44 lg:w-64" src={props.store === "ios" ? appstore : googleplay} alt={props.store} loading="lazy"/>
            </Link>
        </div>
    )

}